import { render, staticRenderFns } from "./imageSlider.vue?vue&type=template&id=b20e40dc&scoped=true"
import script from "./imageSlider.vue?vue&type=script&lang=js"
export * from "./imageSlider.vue?vue&type=script&lang=js"
import style0 from "./imageSlider.vue?vue&type=style&index=0&id=b20e40dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20e40dc",
  null
  
)

export default component.exports